export function getSceneImageClass($img, variants) {
    let matchedClass = null;

    variants.forEach((className) => {
        if (!matchedClass && $img.hasClass(className)) {
            matchedClass = className;
        }
    });

    return matchedClass;
}
